import styled from '@emotion/styled'
import { Card } from '@mui/material'

import {
  HOUSE_CARD_TILE_HEIGHT,
  HOUSE_CARD_TILE_WIDTH_PX
} from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/constants/Constants'

export const StyledCard = styled(Card)`
  width: ${HOUSE_CARD_TILE_WIDTH_PX}px;
  height: ${HOUSE_CARD_TILE_HEIGHT}px;
  display: flex;
  flex-direction: column;
  border-radius: var(--border-radius-card-medium);
  box-shadow: 0 5px 10px -1px rgb(59 71 104 / 5%), 0 2px 4px -3px #3b4768,
    0 2px 40px 0 rgb(59 71 104 / 5%);
  background-color: ${({ theme }) => theme.palette.background.paper};
`
